import * as tslib_1 from "tslib";
import { ApiTypes } from '../../types';
import { SiteMemberPrivacyStatus, } from '../../services/membersApi/SiteMember';
export function isAnonymous(member) {
    return !member.siteMemberId;
}
export function isGroupMember(member) {
    return member.relationship !== ApiTypes.v1.RelationshipWithGroup.NONE;
}
export var Anonymous = {
    imageUrl: null,
    joinedOn: null,
    name: { nick: null },
    relationship: ApiTypes.v1.RelationshipWithGroup.NONE,
    requestedMembershipOn: null,
    roles: [],
    siteMemberId: null,
};
export function isProfilePublic(member) {
    return member.profilePrivacyStatus === SiteMemberPrivacyStatus.PUBLIC;
}
export function memberWrapper(member) {
    return tslib_1.__assign({}, Anonymous, member);
}
//# sourceMappingURL=Member.js.map